
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.057 32.42c-.252.88-.161 1.775.022 2.508l-6.972.022c-.47.01-.9.31-1.05.76-.15.45 0 .95.38 1.24l10.32 7.95c.2.15.43.23.68.23h22.76c.24 0 .48-.08.67-.23l10.32-7.95c.38-.29.53-.79.38-1.24-.15-.45-.57-.76-1.05-.76l-5.488-.018c.434-1.156.665-2.81-.122-4.832-1.33-3.43-7.12-6.95-12.61-9.93l-.91-.49-.011-.006c-2.979-1.604-3.04-1.637-4.109-4.014-.16-.35-.48-.6-.86-.65-.37-.05-.75.09-1 .38-4.384 5.094-2.344 8.512-1.572 9.805l.002.005c.4.66.44.82-.67 1.66-.33.25-1.55.76-2.63 1.2-1.49.61-3.18 1.31-4.62 2.1-.94.52-1.59 1.3-1.86 2.26zm28.77-1.52c.78 2.017.105 3.439-.279 4.024l-13.73-.044h-.01l-1.578.005c.334-.986.957-1.875 4.917-2.885 3.75-.95 4.61-3.17 4.78-4.4.104-.739.03-1.512-.196-2.28 2.724 1.749 5.41 3.82 6.096 5.58zm-11.376-8.659c.015.01.03.02.047.029 2.07 1.23 3.46 3.38 3.23 5.02-.21 1.51-1.81 2.23-3.12 2.56-5.2 1.33-6.04 2.86-6.6 4.73l-.093.313-8.494.027c-.198-.525-.387-1.288-.214-1.9.12-.4.37-.69.79-.92 1.312-.72 2.916-1.382 4.331-1.966l.06-.024c1.64-.67 2.6-1.07 3.13-1.48l.015-.012c.886-.684 2.696-2.083 1.214-4.568-.61-1.02-1.68-2.81.3-5.84.91 1.56 1.8 2.08 4.28 3.42l.9.49.224.121zM26.667 37.12l-15.3.05 7.44 5.73h22l7.44-5.73-18.44-.06-3.14.01z"}})])
          )
        }
      }
    